import i18next from "src/i18n/config";
import RouteService from "src/services/routeService";
import { transformErrorResponse } from "src/store/helpers";
import { PaginatedResponse } from "src/types";

import { BaseQueryFn, EndpointBuilder } from "@reduxjs/toolkit/query";

type DownloadsBuilder = EndpointBuilder<BaseQueryFn, "Releases", "downloadsApi">;

type GetReleasesParams = {
    workspaceId: number;
    pageIndex?: number;
    pageSize?: number;
    includePublicProducts: boolean;
};

type GetReleasesResponse = PaginatedResponse<API.ReleaseFile>;

function getReleases(builder: DownloadsBuilder) {
    return builder.query<GetReleasesResponse, GetReleasesParams>({
        providesTags: ["Releases"],
        transformErrorResponse: (err) => transformErrorResponse(err, i18next.t("pages:downloadsPage.toast.fetchError")),
        query: async ({ workspaceId, pageIndex, pageSize, includePublicProducts }) => {
            const base = await RouteService.getProductRoute();
            return {
                url: `${base}downloads`,
                params: {
                    WorkspaceId: workspaceId,
                    PageIndex: pageIndex,
                    PageSize: pageSize,
                    includePublicProducts,
                },
            };
        },
    });
}

export default { getReleases };
